// Carved verbatim from `src/features/agent-harness/hooks.ts` (ARCFE-1079 · D4).
// `transport` is REQUIRED here — the `agentHarnessClient` default is an app-side
// assembly and re-applied by the old-path delegate. See `query/useQueryRun.ts`.
import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { SubmitTurnRequest } from '../../contracts/harness.types';
import { agentHarnessKeys } from '../../contracts/keys';
import type { RunTransport } from '../../contracts/transport';

export const useMutateSubmitTurn = (transport: RunTransport) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ agentRunId, body }: { agentRunId: string; body: SubmitTurnRequest }) =>
      transport.submitTurn(agentRunId, body),
    onSuccess: (_data, { agentRunId }) => {
      void queryClient.invalidateQueries({
        queryKey: agentHarnessKeys.run(agentRunId),
      });
    },
  });
};
